import { render, staticRenderFns } from "./CloseDialogButton.vue?vue&type=template&id=1a07b46c&scoped=true"
import script from "./CloseDialogButton.vue?vue&type=script&lang=js"
export * from "./CloseDialogButton.vue?vue&type=script&lang=js"
import style0 from "./CloseDialogButton.vue?vue&type=style&index=0&id=1a07b46c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a07b46c",
  null
  
)

export default component.exports